import {eventSourceValidation} from 'src/modules/event-create/validations/event-source-validation';
import {eventTriggerValidation} from 'src/modules/event-create/validations/event-trigger-validation';
import {eventTypeValidation} from 'src/modules/event-create/validations/event-type-validation';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';

export const changeRequestValidation = (eventChangeRequest: EventChangeRequest): string[] => {
    return [
        ...eventTriggerValidation(eventChangeRequest.trigger),
        ...eventSourceValidation(eventChangeRequest.source),
        ...eventTypeValidation(eventChangeRequest.type),
    ];
};
